const pagesIndividualSideNavEn = {
  approvalTasks: 'Approval Tasks',
  operationTasks: 'My Tasks',
  portal: 'Portal',
  request: 'Request',
  requestTasks: 'Request Tasks'
};
export default pagesIndividualSideNavEn;